export default {
      id: "color_bacteria_agro-usage",
      viewBox: "0 0 142 145",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria_agro",
      toString: function () {
        return this.url;
      }
    }